module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr-ca":{"Conditions":"Conditions","Season Total":"Total saison","24 hour":"24 h","48 hour":"48 h","72 hour":"72 h","7 day":"7 jours","Snow Base":"Snow Base"}}')
  delete Component.options._Ctor
}
